// AIGeneratingIcon.jsx - Fixed version for Mantine
import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mantine/core';
import { IconRobot } from '@tabler/icons-react';

// AIGeneratingIcon Component with inline CSS animations (better Mantine compatibility)
const AIGeneratingIcon = ({
  isGenerating = false,
  size = 16,
  color = '#228be6',
  style = {}
}) => {
  // Inline CSS for better compatibility with Mantine
  const animationStyle = isGenerating ? {
    animation: 'aiThinking 2.5s ease-in-out infinite, aiGlow 3s ease-in-out infinite',
    transform: 'translateY(0px)',
  } : {};

  return (
    <>
      {/* Inject keyframes styles only when needed */}
      {isGenerating && (
        <style>
          {`
            @keyframes aiThinking {
              0%, 100% {
                transform: translateY(0px) scale(1);
                opacity: 0.9;
              }
              50% {
                transform: translateY(0px) scale(1.1);
                opacity: 1;
              }
            }
            
            @keyframes aiGlow {
              0%, 100% {
                filter: drop-shadow(0 0 8px rgba(34, 139, 230, 0.3));
              }
              50% {
                filter: drop-shadow(0 0 12px rgba(34, 139, 230, 0.6));
              }
            }
          `}
        </style>
      )}
      
      <Box
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          ...style
        }}
      >
        <IconRobot
          size={size}
          color={color}
          style={{
            ...animationStyle,
            transition: 'all 0.3s ease',
            transformOrigin: 'center bottom',
          }}
        />
      </Box>
    </>
  );
};

AIGeneratingIcon.propTypes = {
  isGenerating: PropTypes.bool,
  size: PropTypes.number,
  color: PropTypes.string,
  style: PropTypes.object,
};

AIGeneratingIcon.defaultProps = {
  isGenerating: false,
  size: 16,
  color: '#228be6',
  style: {},
};

export default AIGeneratingIcon;